import { createSlice } from '@reduxjs/toolkit';
import { Settings } from 'types/settingsType';

interface SettingState {
  settings: Settings;
}

const initialState: SettingState = {
  settings: [] as Settings,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings(state, action) {
      state.settings = action.payload;
    },
  },
});

export const { setSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
